import React from 'react';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

interface IProps {
  onScrollToBottom?: Function;
  bottomDistance?: number;
}

export default class InfinityScroll extends React.PureComponent<IProps> {
  static defaultProps: IProps = {
    bottomDistance: 10
  };
  private subscription: Subscription;

  componentDidMount() {
    this.subscription = fromEvent(window, 'scroll').pipe(debounceTime(100)).subscribe(this.handleScrollToBottom);
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleScrollToBottom = (event: Event) => {
    const isInPageBottom =
      window.innerHeight + (window.scrollY + this.props.bottomDistance) >= document.body.offsetHeight;

    if (isInPageBottom) {
      this.props.onScrollToBottom(event);
    }
  };

  render() {
    return this.props.children;
  }
}
